export default __webpack_public_path__ + "static/media/31t.0c987985.jpg";